import { Fragment } from 'react';
import Card from '../ui/Card';
import Closebutton from '../ui/Closebutton';
import Item from '../ui/Item';
import mohito from '../../img/mohito.jpeg';
import bluehawaii from '../../img/bluehawaii.jpeg';
import lemonade from '../../img/lemonade.jpeg';
import cherrylemonade from '../../img/cherrylemonade.jpeg';
import orange from '../../img/orange.jpeg';

const dummy_data = [
  
    {
        key:'d1',
        name:'Moohito',
        price:35000,
        icon:mohito,

    },
    {
        key:'d2',
        name:'Blue Hawai',
        price:43000,
        icon:bluehawaii,
    },
    {
        key:'d3',
        name:'Lemonade',
        price:35000,
icon:lemonade,
    },
    {
        key:'d4',
        name:'Cherry',
        price:40000,
        icon:cherrylemonade,

    },
    {
        key:'d5',
        name:'Orange',
        price:38000,
        icon:orange,

    },
   
   
] ;


const MainFoods = (props) => {

    const coctailsList = dummy_data.map((coctail) => (
 
    <Item
      key={coctail.id}
      name={coctail.name}
      price={coctail.price}
      icon={coctail.icon}
      description={coctail.description}
    />
  ));
   
  return (
<Fragment>
    <Closebutton onClick={props.onClick}/>
<Card>

{coctailsList}

   </Card>
   </Fragment>
   )
}


export default MainFoods;